module.exports = __webpack_public_path__ + "img/logo-white.d16237d2.png";